import { computed, ref, watch } from "vue";
import { api, baseURL } from "~/plugins/api";
import qs from 'query-string';
import { empresa } from '../empresas';

export const codigo_cliente = ref<number>(0)
export const tipo_relacao = ref<string>('')
export const refresh_token = ref<string>(localStorage.getItem('refresh_token')||'')
export const token_assembleia = ref<any>(null)
export const condominio_id = ref<number>(Number(localStorage.getItem('condominio_id') || '0'))
export const relacao_id = ref<number>(Number(localStorage.getItem('relacao_id')||'0'))
export const relacoes = ref<any[]>([])
export const jwt = ref<string|null>(null)

const state = computed(() => {
    return {
        relacoes: relacoes.value,
        relacao_id: relacao_id.value,
        condominio_id: condominio_id.value
    }
})

export const relacao = computed(() => {
    if (!relacoes.value.length) {
        return null
    }
    if (relacoes.value.length <= relacao_id.value) {
        return null
    }
    return relacoes.value[relacao_id.value]
})

export const condominios = computed(() => {
    if (!relacao.value) {
        return []
    }
    if (!('condominios' in relacao.value)) {
        return []
    }
    return relacao.value.condominios
})

export const condominio = computed(() => {
    if (!condominios.value.length) {
        return null
    }
    
    if (condominios.value.length <= condominio_id.value) {
        return null
    }
    return condominios.value[condominio_id.value]
})

export const codigo_condominio = computed(() => {
    if (!condominio.value) {
        return 0
    }
    return condominio.value.codigo
})

export const url_assembleia = computed(() => {
    
    if (token_assembleia.value === null) {
        return ''
    }  

    
    
    let origin = `https://${empresa.domain}`;
    
    let url = new URL(`${origin}/assembleias`)    
    url.searchParams.set('expires_at', token_assembleia.value.expiresAt)
    url.searchParams.set('codigo_condominio', codigo_condominio.value)
    for (let i in token_assembleia.value) {
        url.searchParams.set(i, token_assembleia.value[i])
    }


    //let url2 = new URL('https://google.com.br/search')
    //url2.searchParams.set('q', url.toString())
    //return `${origin}/assembleias?${query}`;
    return url.toString();
})

export const url_clube_vantagens = computed(() => {
    if (!jwt.value) {
        return ''
    }

    return `${baseURL}/clube-vantagens?jwt=${jwt.value}`
})

const loadTokenAssembleia = async () => {
    try {
        if (!jwt.value) {
            return
        }
        const { data: token } = await api.post('assembleias', {
            refresh_token: refresh_token.value
        })
        
        token_assembleia.value = token
    } catch (e) {
        console.error(e)
    }
}

watch(refresh_token, loadTokenAssembleia)
watch(jwt, loadTokenAssembleia)

loadTokenAssembleia()